export default __webpack_public_path__ + "static/media/UnionDot.5b50e0cc.png";